

import React, { useEffect, useState } from 'react';

import { DashboardLayout, GeneralTable, Button, SubmenuTooltip, MoreButton } from "components";

import { func_validation, getTotalCountFromHeader, isObjectEmpty } from 'functions';
import { tableColumns } from './hooks';

import { useDeleteInvoice, useAlertMessage,
    useUnpostedInvoices, useUncreditedInvoices,
    deliveredInvoices, usePendingInvoices 
} from './hooks';

import 'assets/scss/billingPortal/modules/invoices/advancePayInvoices.scss';
import { MultiFilters } from 'components/filters/MultiFilters';




export default function AdvancePayInvoicesPresentation(props) {    
    const {
        invoiceList,
        invoiceListHeaders,
        getInvoiceList_requesting,

        isInvoiceRecordUpdatedSuccessfully,
        history,
        
        postCreditNote_requesting,
        sendEmail_requesting,
        postToSQLAccount_requesting,
    } = props;

    let status = history?.location?.search?.substring("status".length + 2);
    const [currentTabId, setCurrentTabId] = useState(status? status:"unposted");
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [isMainActionClicked, setIsMainActionClicked] = useState();
    const [isFilterReset, setIsFilterReset] = useState();
    const [isMounted, setIsMounted] = useState();

    useEffect(() => {
        if (!isMounted) setIsMounted(true);
    }, [isMounted])
    useEffect(() => {
        if (isMounted) setIsFilterReset(true);
    }, [currentTabId]);
    useEffect(() => {
        if (isFilterReset) setIsFilterReset(false);
    }, [isFilterReset]);

    const {
        setAlertMsg,
        alertMsgDisplay
    } = useAlertMessage(props);

    const {
        deleteInvoiceModal,
        setIsModalVisible_deleteInvoice
    } = useDeleteInvoice({
        ...props,
        selectedInvoices, setSelectedInvoices,
        setAlertMsg
    });

    const {
        isExportingFile: isExportingFile_unposted,
        tableActions: tableActions_unposted,
        mainTableActionDetails: mainTableActionDetails_unposted,
        tabDetails: tabDetails_unposted,
        filters: filters_unposted,
        postInvoiceModal
    } = useUnpostedInvoices({
        ...props,
        selectedInvoices, setSelectedInvoices,
        setIsModalVisible_deleteInvoice,
        setAlertMsg
    });

    const {
        isExportingFile: isExportingFile_uncredited,
        tableActions: tableActions_uncredited,
        mainTableActionDetails: mainTableActionDetails_uncredited,
        tabDetails: tabDetails_uncredited,
        filters: filters_uncredited
    } = useUncreditedInvoices({
        ...props,
        selectedInvoices, setSelectedInvoices,
        setIsModalVisible_deleteInvoice,
        setAlertMsg
    });

    const {
        isExportingFile: isExportingFile_pending,
        tableActions: tableActions_pending,
        mainTableActionDetails: mainTableActionDetails_pending,
        tabDetails: tabDetails_pending,
        filters: filters_pending
    } = usePendingInvoices({
        ...props,
        selectedInvoices, setSelectedInvoices,
        setIsModalVisible_deleteInvoice,
        setAlertMsg
    });

    const {
        tabDetails: tabDetails_delivered,
        tableActions: tableActions_delivered,
        filters: filters_delivered
    } = deliveredInvoices({
        ...props,
        selectedInvoices,
        setIsModalVisible_deleteInvoice,
    });

    let isMainActionHidden = false;
    let isActionHidden = false;
    let isActionLoading = false;
    let isExportingFile = false;
    let tableActions = [];
    let mainTableActionDetails = {};
    let mainActionText = "";
    let filters = {}
    switch (currentTabId) {
        case "uncredited":
            isExportingFile = isExportingFile_uncredited;
            tableActions = tableActions_uncredited;
            mainTableActionDetails = mainTableActionDetails_uncredited;
            mainActionText = "Post Credit";
            filters = filters_uncredited;
            isActionLoading = postCreditNote_requesting;
            break;
        case "pending":
            isExportingFile = isExportingFile_pending;
            tableActions = tableActions_pending;
            mainTableActionDetails = mainTableActionDetails_pending;
            mainActionText = "Send to Customer";
            filters = filters_pending;
            isActionLoading = sendEmail_requesting;
            break;
        case "delivered":
            isMainActionHidden = true;
            tableActions = tableActions_delivered;
            filters = filters_delivered;
            break;
        default:
            // unposted
            isExportingFile = isExportingFile_unposted;
            tableActions = tableActions_unposted;
            mainTableActionDetails = mainTableActionDetails_unposted;
            mainActionText = "Post Invoices";
            filters = filters_unposted;
            isActionLoading = postToSQLAccount_requesting;
            break;            
    }

    let mainTableActionDetails_onClick = func_validation.getObjectPropertyValue(mainTableActionDetails, "onClick");
    let mainTableActionDetails_isDisabled = func_validation.getObjectPropertyValue(mainTableActionDetails, "isDisabled");
    let mainTableActionDetails_icon = func_validation.getObjectPropertyValue(mainTableActionDetails, "icon");
    let mainTableActionDetails_alt = func_validation.getObjectPropertyValue(mainTableActionDetails, "alt");

    useEffect(() => {
        if (!isActionLoading) setIsMainActionClicked(false);
    }, [isActionLoading]);    
    
    let tabsDetails = [tabDetails_unposted, tabDetails_uncredited, tabDetails_pending, tabDetails_delivered];

    return (
        <div className={"advancePayInvoices"}>
            <DashboardLayout
                headerTitle={"Commitment Pay Invoices"}

                bodyClassName={"advancePayInvoices-body"}
                body={(
                    <GeneralTable
                        className={"advancePayInvoices-table"}
                        columns={tableColumns.getColumns()}
                        data={invoiceList}
                        minRows={10}

                        getTableData={props.getInvoiceList}
                        isTableDataRequestPrevented={isExportingFile}

                        isTableRefreshRequired={isInvoiceRecordUpdatedSuccessfully}

                        onRowSelectionChange={setSelectedInvoices}

                        topOuterTableHeader={() => alertMsgDisplay}
                        outerTableHeader={() => {
                            return (
                                <div className={"advancePayInvoices-table-header d-flex align-items-center justify-content-between "}>
                                    <div className={"header__title tableHeaderTitle "}>
                                        List
                                    </div>

                                    {isActionHidden? "":(
                                        <div className={"advancePayInvoices-tableHeader-action d-flex align-items-center"}>
                                            {isMainActionHidden? "":(
                                                <div className={"advancePayInvoices-tableHeaderAction-mainActionWrapper"}>
                                                    <Button
                                                        className={"advancePayInvoices-tableHeaderAction-mainAction tableHeaderButtonPadding d-flex align-items-center"}
                                                        handleOnClick={() => {
                                                            mainTableActionDetails_onClick();
                                                            setIsMainActionClicked(true);
                                                        }}

                                                        isDisabled={mainTableActionDetails_isDisabled}
                                                        isLoading={isActionLoading && isMainActionClicked}
                                                        isDecoration_primaryTransparent isSpinnerColorPrimary
                                                    >
                                                        <React.Fragment>
                                                            <img
                                                                className={"advancePayInvoices-tableHeaderAction-icon"}
                                                                src={mainTableActionDetails_icon}
                                                                alt={mainTableActionDetails_alt}
                                                            />

                                                            <span className={"advancePayInvoices-tableHeaderAction-text tableHeaderButtonText "}>{mainActionText}</span>
                                                        </React.Fragment>
                                                    </Button>
                                                </div>
                                            )}

                                            <SubmenuTooltip
                                                buttonClassName={""}
                                                menuItems={tableActions}
                                            >
                                                <MoreButton
                                                    className={"advancePayInvoices-tableHeaderAction-moreActions"}
                                                    iconClassName={"advancePayInvoices-tableHeaderMoreAction-icon"}
                                                />
                                            </SubmenuTooltip>
                                        </div>
                                    )}
                                </div>
                            );
                        }}

                        bottomOuterTableHeader={(outerTableHeader_props) => {
                            const {
                                filterOptions, setFilterOptions
                            } = outerTableHeader_props;

                            return (
                                <div className={"table__table-filter d-flex flex-wrap align-items-center"}>
                                    <MultiFilters
                                        defaultFilterOption={{
                                            label: "Invoice ID", 
                                            propertyName: "id",
                                            placeholder: "Invoice ID",
                                            inputType: "search",
                                        }}
                                        filterOptions={[
                                            {
                                                label: "Invoice ID", 
                                                propertyName: "id",
                                                placeholder: "Invoice ID",
                                                inputType: "search",
                                            },
                                            {
                                                label: "Reference Doc. No.", 
                                                propertyName: "documentNo",
                                                placeholder: "Reference Document No.",
                                                inputType: "search",
                                            },
                                            {
                                                label: "Account Code", 
                                                propertyName: "accountCode",
                                                placeholder: "Account Code",
                                                inputType: "search"
                                            },
                                            {
                                                label: "Issue Date", 
                                                propertyName: "issueDateTime",
                                                placeholder: "Issue Date",
                                                inputType: "date"
                                            },
                                            {
                                                label: "Document Date", 
                                                propertyName: "docDate",
                                                placeholder: "Document Date",
                                                inputType: "date"
                                            },
                                        ]}
                                        dropdownPlaceholder={"Select Filter"}
                                        onApplyFilter={(inputFilters) => {
                                            // find matched tab
                                            let defaultFilter = {}
                                            tabsDetails.map((tabObj, idx) => {
                                                if (tabObj?.id === currentTabId) {
                                                    defaultFilter = tabObj?.filters? tabObj?.filters: filters;
                                                }
                                            })
                                            setFilterOptions(isObjectEmpty(inputFilters)? defaultFilter: { ...filterOptions, ...inputFilters});
                                        }}
                                        isResetFromParentRequired={isFilterReset}
                                    />
                                </div>
                            );
                        }}

                        tabsDetails={tabsDetails}
                        onTabIdChange={setCurrentTabId}
                        defaultTabId={currentTabId}
                        defaultFilter={filters}

                        isExpanderRequired

                        isTableDataLoading={getInvoiceList_requesting && !isExportingFile}

                        isUsingPagination
                        totalRecords={getTotalCountFromHeader(invoiceListHeaders)}

                        isColumnResizeable isAllColumnWidthEqual
                        isTableOddRowsDarken
                        isCheckboxRequired
                        isCheckboxColumnFirst
                        isTabRequired
                    />
                )}
            />

            {/* Delete Alert */}
            {deleteInvoiceModal}

            {/* Post Invoice */}
            {postInvoiceModal}
        </div>
    );
}